{
	"customSavedCartDetails": {
		"cartName": "Name",
		"cartDescription": "Beschreibung",
		"cartId": "ID",
		"dateSaved": "Speicherdatum",
		"items": "Anzahl der Produkte",
		"quantity": "Gesamtanzahl",
		"total": "Warenwert gesamt",
		"editSavedCart": "Ändern",
		"deleteSavedCart": "Löschen",
		"addSelectedItems": "Hinzufügen",
		"emptyCartItems": "Warenkorb leeren",
		"publicCart": "Warenkorb öffentlich",
		"yes": "Ja",
		"no": "Nein",
		"publicCartFlagUpdated": "Warenkorb wurde erfolgreich editiert",
		"publicCartFlagError": "Warenkorb konnte nicht aktualisiert werden",
		"publicFlagColumn": "Privat/Öffentlich",
		"public": "Öffentlich",
		"private": "Privat",
		"active": "Aktiv"
	},
	"customSavedCartList": {
		"savedCarts": "Liste gespeicherte Warenkörbe ({{count}})",
		"cartName": "Name",
		"cartId": "ID",
		"dateSaved": "Speicherdatum",
		"cartDescription": "Beschreibung",
		"quantity": "Anzahl",
		"total": "Summe",
		"actions": "Aktion",
		"makeCartActive": "Aktivieren",
		"notFound": "Keine gespeicherten Warenkörbe gefunden",
		"swapCartNoActiveCart": "Vorhandener Warenkorb wurde von {{cartName}} erfolgreich aktiviert.",
		"swapCartWithActiveCart": "Vorhandener Warenkorb wurde von {{cartName}} erfolgreich aktiviert. Ihre vorherigen Artikel wurden in einem Warenkorb {{previousCartName}} gespeichert."
	},
	"customSavedCartPage": {
		"messages": {
			"cartSaved": "Ihre Artikel wurden erfolgreich im Warenkorb \"{{cartName}}\" für später gespeichert."
		}
	},
	"customSavedCartDialog": {
		"saveForLater": "Warenkorb speichern",
		"itemsSavedForLater": "Ihr Warenkorb wird in die Liste der gespeicherten Warenkörbe verschoben.",
		"savedCartName": "Name",
		"savedCartDescription": "Beschreibung",
		"optional": "optional",
		"charactersLeft": "Zeichen übrig: {{count}}",
		"cancel": "Abbrechen",
		"save": "Speichern",
		"followingCartDelete": "Der folgende Warenkorb wird gelöscht",
		"delete": "Löschen",
		"deleteCartSuccess": "Warenkorb wurde erfolgreich gelöscht",
		"editCartSuccess": "Warenkorb wurde erfolgreich editiert",
		"editSavedCart": "Ändern",
		"deleteSavedCart": "Löschen",
		"name": "Name",
		"id": "ID",
		"description": "Beschreibung",
		"quantity": "Anzahl",
		"total": "Summe",
		"emptyCart": "Dieser Wahrenkorb enthält keine Produkte"
	},
  "uigAddToSavedCart": {
	"printExport": "Drucken/Exportieren",
	"emptyCart": "Warenkorb leeren"
  }
}
